import { EventMetadataSchema, EventMetadataType } from '../types/eventMetadata';
import { medtechApi } from './index';

const eventMetadataApi = {
  async getMetadata(company: number): Promise<EventMetadataType> {
    const res = await medtechApi.get(`/v2/${company}/workflowsmetadata`);
    return EventMetadataSchema.parse(res.data);
  },
};

export default eventMetadataApi;
